import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"
import { playerFacingError } from "src/utils/errorMessages"

/* Closing the account. The answer carries nothing — the caller logs out, which is what makes the
   session go — so this returns nothing and changes no state of its own.

   **The refusal is returned, not announced**, the same choice `changeUsername` makes and for the
   same reason: there is exactly one, "you are in a lobby or a live game", and it is about the
   button the player is looking at rather than something that happened somewhere on the map.
   `handlesOwnErrors` keeps the axios interceptor from adding "Request failed with status code 409"
   over it, and the sentence itself comes from `errorMessages.js` so it is in the player's own
   language rather than in the server's. */
export const thunk = createAsyncThunk("user/deleteAccount", async (_, { rejectWithValue }) => {
  try {
    await apiClient.delete("/users/me/", { handlesOwnErrors: true })
    return true
  } catch (error) {
    return rejectWithValue({ message: playerFacingError(error.response?.data?.code) })
  }
})

// Nothing to write: the account this slice describes no longer exists, and the caller's `logoutUser`
// resets every slice a moment later.
export const onSucceed = null

const thunkObject = { thunk, onSucceed }
export default thunkObject
